// Which company's portal is this browser on?
//
// Each company can be served from its own subdomain, e.g. acme.hrms.example.com. Set
// REACT_APP_BASE_DOMAIN to the root domain (e.g. "hrms.mqbit.in"); the label in front of it is the
// company's subdomain. On the root domain itself, on localhost, or when the variable is unset there
// is no subdomain and the account's own company is used — exactly how the app behaved before
// multi-tenancy.
//
// This value is only a HINT sent to the login page (so the right branding shows and a user cannot
// sign in on another company's portal). It is never what decides which data a signed-in user sees —
// the server takes that from the user's own account.

const BASE_DOMAIN = (process.env.REACT_APP_BASE_DOMAIN || '').trim().toLowerCase().replace(/^\./, '');

export function getTenantSubdomain(hostname: string = window.location.hostname): string | null {
  if (!BASE_DOMAIN) return null;
  const host = hostname.trim().toLowerCase();
  const suffix = `.${BASE_DOMAIN}`;
  if (!host.endsWith(suffix)) return null;

  const label = host.slice(0, -suffix.length);
  // Only a single label counts ("acme"), not nested hosts ("a.b").
  return label && !label.includes('.') && label !== 'www' ? label : null;
}

export const TENANT_HEADER = 'X-Tenant';
